export default __webpack_public_path__ + "static/media/LOGO_ΔΗΜΟΥ_ΠΩΓΩΝΙΟΥ-removebg-preview.a3d379f3.png";